import Header from './components/Header';
import HeroSection from './components/HeroSection';
import AppSection from './components/AppSection';
import IndexSection from './components/IndexSection';
import TopicsSection from './components/TopicsSection';
import CardsSection from './components/CardsSection';
import FeaturesSection from './components/FeaturesSection';
import AboutSection from './components/AboutSection';
import UpdatesSection from './components/UpdatesSection';
import MediaSection from './components/MediaSection';
import RankingSection from './components/RankingSection';
import CarouselSection from './components/CarouselSection';
import ContactSection from './components/ContactSection';
import FaqSection from './components/FaqSection';
import CommentsSection from './components/CommentsSection';
import Footer from './components/Footer';

export default function Home() {
  return (
    <>
      <Header />
      <main>
        <HeroSection />
        <AppSection />
        <IndexSection />
        <TopicsSection />
        <CardsSection />
        <FeaturesSection />
        <AboutSection />
        <UpdatesSection />
        <MediaSection />
        <RankingSection />
        <CarouselSection />
        <ContactSection />
        <FaqSection />
        <CommentsSection />
      </main>
      <Footer />
    </>
  );
}